import api from '../api';
import { tokenStorage } from '../../utils/encryptedCookie';

const setAuthHeader = () => {
  const token = tokenStorage.get();
  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

export const getBalance = async () => {
  try {
    const response = await api.get('/configurations/balance', {
      headers: setAuthHeader(),
    });
    return response.data.balance;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 'Erro na pesagem da API.'
    );
  }
};